import ApiBase from '../ApiBase';

class To extends ApiBase {
    route = '/networking/to';
}

export default new To;
